import styles from "./styles.module.css";
import { useState, useContext, useEffect } from "react";
import { BlocksValue } from "../../../../contexts/blocks";
import {
  WorkflowsValue,
  WorkflowsDisbatch,
} from "../../../../contexts/workflows";
import EventEditor from "./eventeditor";
import useParentSources from "../../../../utils/useparentsources.js";

export default function Actions({ block, path, onChange, setWorkflows }) {
  const blocks = useContext(BlocksValue);
  const sources = useParentSources(path);
  const [schema, setSchema] = useState(null);

  useEffect(() => {
    const _schema = blocks.find((x) => x.name === block.component);
    setSchema(_schema);
  }, [block.component]);

  if (!schema) {
    return null;
  }
  return (
    <div className={styles.events}>
      {schema.events.map((event, index) => {
        return (
          <EventEditor
            key={event.name}
            event={event}
            index={index}
            block={block}
            onChange={onChange}
            sources={sources}
          />
        );
      })}
    </div>
  );
}
